module.exports = __webpack_public_path__ + "media/images/marumotakagi/marumo_banner-ade786fb9441ca0f5457d76013408bbd.gif";